// extracted by mini-css-extract-plugin
export default {"textarea":"Inspectlet_textarea__4ItIz","textareaContainer":"Inspectlet_textareaContainer__JnnF6"};